import request from "@/utils/request"

export function findRoleAuthorizeRecordPage(condition) {
  return request({
    url: "/role-authorize-record/findPage",
    method: "POST",
    data: condition
  })
}
